export const NAO_ENCONTRADO = 'Não foram encontrados lançamentos neste período'
export const NAO_HA_DADOS_PARA_IMPRIMIR = 'Não há dados para gerar o PDF'
